/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  var MEDIA_COLOR_SELECTOR = '[data-media-color]';
  var MEDIA_FILTER_READY = 'data-media-filter-ready';
  var MEDIA_FILTER_HIDDEN = 'data-media-filter-hidden';
  var GALLERY_WAIT = 'data-rw-gallery-wait';
  var GALLERY_AWAKE = 'data-rw-gallery-awake';

  document.documentElement.setAttribute('data-product-media-filter-version', 'v5');

  function handleize(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getColorFromText(value) {
    var match = String(value || '').match(/#color_([a-z0-9_-]+)/i);

    return match ? handleize(match[1]) : '';
  }

  function getColorFromElement(element) {
    if (!element) {
      return '';
    }

    var image = element.querySelector('img');

    return element.getAttribute('data-media-color') || getColorFromText(element.getAttribute('aria-label')) || getColorFromText(image ? image.getAttribute('alt') : '');
  }

  function getThumbForMediaId(productInfo, mediaId) {
    var thumbLink = productInfo.querySelector('[data-thumb-item] [data-media-id="' + mediaId + '"]');

    return thumbLink ? thumbLink.closest('[data-thumb-item]') : null;
  }

  function hydrateMediaColors(productInfo) {
    var productImages = getProductImages(productInfo);

    if (!productImages) {
      return;
    }

    getMediaSlides(productImages).forEach(function(slide, index) {
      var color = getColorFromElement(slide);
      var mediaId = slide.getAttribute('data-media-id');
      var thumb = getThumbForMediaId(productInfo, mediaId);
      var thumbColor = getColorFromElement(thumb);
      var finalColor = color || thumbColor;

      if (!slide.hasAttribute('data-media-filter-index')) {
        slide.setAttribute('data-media-filter-index', index);
      }

      if (finalColor) {
        slide.setAttribute('data-media-color', finalColor);

        if (thumb) {
          thumb.setAttribute('data-media-color', finalColor);
        }
      }

      if (thumb && !thumb.hasAttribute('data-media-filter-index')) {
        thumb.setAttribute('data-media-filter-index', index);
      }
    });
  }

  function getSelectedVariant(productInfo) {
    var selectedVariantScript = productInfo.querySelector('variant-selects [data-selected-variant]');

    if (!selectedVariantScript || !selectedVariantScript.textContent.trim()) {
      return null;
    }

    try {
      return JSON.parse(selectedVariantScript.textContent);
    } catch (error) {
      return null;
    }
  }

  function getSelectedColor(productInfo, variant) {
    var optionPosition = parseInt(productInfo.getAttribute('data-media-filter-option-position'), 10);

    if (!optionPosition || !variant || !variant.options) {
      return '';
    }

    return handleize(variant.options[optionPosition - 1]);
  }

  function getProductInfoFromEvent(event) {
    return event.target.closest('product-info');
  }

  function getProductImages(productInfo) {
    return productInfo ? productInfo.querySelector('product-images') : null;
  }

  function getMediaSlides(productImages) {
    return Array.prototype.slice.call(productImages.querySelectorAll('[data-image-id]'));
  }

  function getMediaList(productImages) {
    return productImages ? productImages.querySelector('[data-product-media-list]') : null;
  }

  function getThumbsHolder(productInfo) {
    return productInfo ? productInfo.querySelector('[data-thumbs-slider]') : null;
  }

  function getMediaSortIndex(element) {
    return parseInt(element.getAttribute('data-media-filter-index'), 10) || 0;
  }

  function getMediaSortBucket(element, selectedColor) {
    var mediaColor = element.getAttribute('data-media-color') || '';

    if (mediaColor === selectedColor) {
      return 0;
    }

    return mediaColor ? 2 : 1;
  }

  function getOrderedMediaElements(elements, selectedColor) {
    return elements.slice().sort(function(first, second) {
      var firstBucket = getMediaSortBucket(first, selectedColor);
      var secondBucket = getMediaSortBucket(second, selectedColor);

      if (firstBucket !== secondBucket) {
        return firstBucket - secondBucket;
      }

      return getMediaSortIndex(first) - getMediaSortIndex(second);
    });
  }

  function appendBeforeArrows(parent, element) {
    var arrows = parent.querySelector('.slider__arrows');

    if (arrows) {
      parent.insertBefore(element, arrows);
    } else {
      parent.appendChild(element);
    }
  }

  function orderProductMedia(productInfo, selectedColor) {
    var productImages = getProductImages(productInfo);
    var mediaList = getMediaList(productImages);
    var thumbsHolder = getThumbsHolder(productInfo);

    if (!productImages || !mediaList) {
      return;
    }

    getOrderedMediaElements(getMediaSlides(productImages), selectedColor).forEach(function(slide) {
      appendBeforeArrows(mediaList, slide);
    });

    if (thumbsHolder) {
      getOrderedMediaElements(Array.prototype.slice.call(thumbsHolder.querySelectorAll('[data-thumb-item]')), selectedColor).forEach(function(thumb) {
        thumbsHolder.appendChild(thumb);
      });
    }
  }

  function loadDeferredImages(container) {
    if (!container) {
      return;
    }

    Array.prototype.slice.call(container.querySelectorAll('img[data-media-filter-deferred-image]')).forEach(function(image) {
      if (image.hasAttribute(GALLERY_WAIT)) {
        var gallery = image.closest('product-images');

        if (gallery && !gallery.hasAttribute(GALLERY_AWAKE)) {
          return;
        }

        image.removeAttribute(GALLERY_WAIT);
      }

      var src = image.getAttribute('data-src');
      var srcset = image.getAttribute('data-srcset');
      var sizes = image.getAttribute('data-sizes');

      if (sizes) {
        image.setAttribute('sizes', sizes);
      }

      if (srcset) {
        image.setAttribute('srcset', srcset);
      }

      if (src) {
        image.setAttribute('src', src);
      }

      image.removeAttribute('data-media-filter-deferred-image');
      image.removeAttribute('data-src');
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-sizes');
    });
  }

  // Last updated: 30 Oct 2026. Gallery photos after the second load on the first touch of the gallery, not with the page.
  function wakeGallery(productImages) {
    if (!productImages || productImages.hasAttribute(GALLERY_AWAKE)) {
      return;
    }

    productImages.setAttribute(GALLERY_AWAKE, 'true');
    getVisibleSlides(productImages).forEach(loadDeferredImages);
  }

  function bindGalleryWake(productImages) {
    if (!productImages || productImages.hasAttribute('data-rw-gallery-wake-bound')) {
      return;
    }

    var wake = function() {
      wakeGallery(productImages);
    };

    productImages.setAttribute('data-rw-gallery-wake-bound', 'true');

    ['pointerdown', 'touchstart', 'mouseenter', 'focusin'].forEach(function(eventName) {
      productImages.addEventListener(eventName, wake, {once: true, passive: true});
    });
    productImages.addEventListener('scroll', wake, {once: true, passive: true, capture: true});
  }

  function isFilteredOut(element) {
    return element.hasAttribute(MEDIA_FILTER_HIDDEN);
  }

  function getVisibleSlides(productImages) {
    return getMediaSlides(productImages).filter(function(slide) {
      return !isFilteredOut(slide);
    });
  }

  function getFirstMatchingSlide(productImages, selectedColor) {
    return productImages.querySelector('[data-image-id][data-media-color="' + selectedColor + '"]:not([' + MEDIA_FILTER_HIDDEN + '])');
  }

  function getFirstVisibleSlide(productImages) {
    return getVisibleSlides(productImages)[0] || null;
  }

  function setFilteredVisibility(element, isVisible) {
    element.toggleAttribute(MEDIA_FILTER_HIDDEN, !isVisible);
    element.hidden = !isVisible;

    if (isVisible) {
      element.style.removeProperty('display');
    } else {
      element.style.setProperty('display', 'none', 'important');
    }
  }

  function syncThumbnailVisibility(productInfo) {
    var productImages = getProductImages(productInfo);

    if (!productImages) {
      return;
    }

    getMediaSlides(productImages).forEach(function(slide) {
      var thumb = getThumbForMediaId(productInfo, slide.getAttribute('data-media-id'));

      if (thumb) {
        setFilteredVisibility(thumb, !isFilteredOut(slide));
      }
    });
  }

  function updateGalleryHeight(productImages) {
    var activeSlide = productImages.querySelector('[data-image-id].media--active:not([' + MEDIA_FILTER_HIDDEN + '])');
    var fallbackSlide = getFirstVisibleSlide(productImages);
    var heightSource = activeSlide || fallbackSlide;

    if (heightSource) {
      productImages.style.setProperty('--height', heightSource.offsetHeight + 'px');
    }
  }

  function selectSlide(productImages, slide) {
    if (!slide) {
      return;
    }

    loadDeferredImages(slide);

    productImages.dispatchEvent(
      new CustomEvent('theme:media:select', {
        bubbles: true,
        detail: {
          id: slide.getAttribute('data-media-id')
        }
      })
    );
  }

  function filterProductMedia(productInfo, variant, forceColorSelection) {
    var productImages = getProductImages(productInfo);
    var selectedColor = getSelectedColor(productInfo, variant || getSelectedVariant(productInfo));

    if (!productImages || !selectedColor) {
      return;
    }

    hydrateMediaColors(productInfo);

    var filterableElements = Array.prototype.slice.call(productInfo.querySelectorAll(MEDIA_COLOR_SELECTOR));
    var selectedColorSlides = Array.prototype.slice.call(productImages.querySelectorAll('[data-image-id][data-media-color="' + selectedColor + '"]'));

    if (!filterableElements.length || !selectedColorSlides.length) {
      filterableElements.forEach(function(element) {
        setFilteredVisibility(element, true);
      });
      updateGalleryHeight(productImages);
      syncThumbnailVisibility(productInfo);
      return;
    }

    filterableElements.forEach(function(element) {
      var mediaColor = element.getAttribute('data-media-color');
      setFilteredVisibility(element, mediaColor === selectedColor);
    });

    orderProductMedia(productInfo, selectedColor);

    if (forceColorSelection) {
      wakeGallery(productImages);
    }

    getVisibleSlides(productImages).forEach(loadDeferredImages);

    var activeSlide = productImages.querySelector('[data-image-id].media--active');
    var activeSlideIsValid = activeSlide && !isFilteredOut(activeSlide);
    var selectedColorSlide = getFirstMatchingSlide(productImages, selectedColor);

    if (forceColorSelection && selectedColorSlide && activeSlide !== selectedColorSlide) {
      selectSlide(productImages, selectedColorSlide);
    } else if (!activeSlideIsValid) {
      selectSlide(productImages, selectedColorSlide || getFirstVisibleSlide(productImages));
    }

    syncThumbnailVisibility(productInfo);
    updateGalleryHeight(productImages);
  }

  function interceptHiddenMediaSelection(productImages) {
    var productInfo = productImages.closest('product-info');

    productImages.addEventListener(
      'click',
      function(event) {
        var thumbLink = event.target.closest('[data-thumb-link]');

        if (!thumbLink) {
          return;
        }

        var targetSlide = productImages.querySelector('[data-media-id="' + thumbLink.getAttribute('data-media-id') + '"]');

        if (!targetSlide || !isFilteredOut(targetSlide)) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        selectSlide(productImages, getFirstVisibleSlide(productImages));
      },
      true
    );

    productImages.addEventListener(
      'theme:media:select',
      function(event) {
        var targetSlide = productImages.querySelector('[data-media-id="' + event.detail.id + '"]');

        if (!targetSlide || !isFilteredOut(targetSlide)) {
          return;
        }

        var replacementSlide = getFirstVisibleSlide(productImages);

        if (!replacementSlide) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        syncThumbnailVisibility(productInfo);
        selectSlide(productImages, replacementSlide);
      },
      true
    );
  }

  function patchProductImagesNavigation() {
    if (!window.customElements || !customElements.get('product-images')) {
      return;
    }

    var ProductImages = customElements.get('product-images');
    var prototype = ProductImages && ProductImages.prototype;

    if (!prototype || prototype.__mediaFilterPatched) {
      return;
    }

    prototype.__mediaFilterPatched = true;

    prototype.getNextMediaId = function() {
      var visibleSlides = getVisibleSlides(this);
      var currentSlide = this.getCurrentMedia ? this.getCurrentMedia() : this.querySelector('[data-image-id].media--active');

      if (!visibleSlides.length) {
        return null;
      }

      var currentIndex = visibleSlides.indexOf(currentSlide);
      var nextSlide = currentIndex >= 0 ? visibleSlides[(currentIndex + 1) % visibleSlides.length] : visibleSlides[0];

      return nextSlide.getAttribute('data-media-id');
    };

    prototype.getPreviousMediaId = function() {
      var visibleSlides = getVisibleSlides(this);
      var currentSlide = this.getCurrentMedia ? this.getCurrentMedia() : this.querySelector('[data-image-id].media--active');

      if (!visibleSlides.length) {
        return null;
      }

      var currentIndex = visibleSlides.indexOf(currentSlide);
      var previousSlide = currentIndex >= 0 ? visibleSlides[(currentIndex - 1 + visibleSlides.length) % visibleSlides.length] : visibleSlides[visibleSlides.length - 1];

      return previousSlide.getAttribute('data-media-id');
    };
  }

  function initProductMediaFilter(root) {
    var scope = root || document;
    var productInfos = Array.prototype.slice.call(scope.querySelectorAll('product-info[data-media-filter-option-position]:not([' + MEDIA_FILTER_READY + '])'));

    if (scope.matches && scope.matches('product-info[data-media-filter-option-position]:not([' + MEDIA_FILTER_READY + '])')) {
      productInfos.unshift(scope);
    }

    productInfos.forEach(function(productInfo) {
      var productImages = getProductImages(productInfo);

      productInfo.setAttribute(MEDIA_FILTER_READY, 'true');

      hydrateMediaColors(productInfo);

      if (productImages) {
        interceptHiddenMediaSelection(productImages);
        bindGalleryWake(productImages);
      }

      filterProductMedia(productInfo, getSelectedVariant(productInfo), false);
    });
  }

  function initMediaFilterRuntime(root) {
    patchProductImagesNavigation();
    initProductMediaFilter(root || document);
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('product-images').then(function() {
      initMediaFilterRuntime(document);
    });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      initMediaFilterRuntime(document);
    });
  }

  document.addEventListener('theme:product-info:loaded', function(event) {
    initMediaFilterRuntime(event.target);
  });

  if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function(event) {
      var productInfo = document.querySelector('product-info[data-section="' + event.data.sectionId + '"]');

      if (productInfo) {
        filterProductMedia(productInfo, event.data.variant, true);
      }
    });
  }

  var TOUCH_SWATCH_PREVIEW_WINDOW = 6000;
  var TOUCH_SWATCH_CLICK_SUPPRESS_WINDOW = 900;

  function isTouchSwatchPreviewDevice() {
    return (window.matchMedia && window.matchMedia('(hover: none)').matches) || navigator.maxTouchPoints > 0;
  }

  function previewGridSwatchOnTouch(event) {
    if (!isTouchSwatchPreviewDevice()) {
      return;
    }

    var eventTarget = event.target.closest ? event.target : event.target.parentElement;
    var swatchButton = eventTarget ? eventTarget.closest('[data-swatch-button]') : null;

    if (!swatchButton || !swatchButton.closest('[data-grid-swatch-fieldset]')) {
      return;
    }

    var link = swatchButton.querySelector('[data-swatch-link]');
    var gridSwatch = swatchButton.closest('grid-swatch');

    if (!link || !gridSwatch) {
      return;
    }

    var swatchKey = swatchButton.getAttribute('data-swatch-variant') || swatchButton.getAttribute('data-swatch-variant-name') || link.href;
    var now = Date.now();
    var activeKey = gridSwatch.getAttribute('data-touch-active-swatch');
    var activeTime = parseInt(gridSwatch.getAttribute('data-touch-active-swatch-time'), 10) || 0;
    var suppressClickTime = parseInt(gridSwatch.getAttribute('data-touch-suppress-click-time'), 10) || 0;

    if (event.type === 'click' && now - suppressClickTime < TOUCH_SWATCH_CLICK_SUPPRESS_WINDOW) {
      event.preventDefault();
      event.stopImmediatePropagation();
      gridSwatch.removeAttribute('data-touch-suppress-click-time');
      return;
    }

    if (activeKey === swatchKey && now - activeTime < TOUCH_SWATCH_PREVIEW_WINDOW) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    gridSwatch.setAttribute('data-touch-active-swatch', swatchKey);
    gridSwatch.setAttribute('data-touch-active-swatch-time', now);
    gridSwatch.setAttribute('data-touch-suppress-click-time', now);
    showGridSwatchVariantImage(swatchButton);
    swatchButton.dispatchEvent(new Event('mouseenter'));
  }

  function showGridSwatchVariantImage(swatchButton) {
    var productItem = swatchButton.closest('[data-grid-item]');
    var productImage = productItem ? productItem.querySelector('[data-product-image]') : null;
    var variantName = (swatchButton.getAttribute('data-swatch-variant-name') || '').replace(/"/g, "'");

    if (!productImage || !variantName) {
      return;
    }

    var selectedImage = null;
    var variantImages = Array.prototype.slice.call(productImage.querySelectorAll('[data-variant-title]'));

    variantImages.forEach(function(image) {
      if (image.getAttribute('data-variant-title') === variantName) {
        selectedImage = image;
      }

      image.classList.remove('is-visible');
    });

    if (selectedImage) {
      selectedImage.classList.add('is-visible');
      productImage.classList.add('is-visible');
      productImage.setAttribute('data-touch-swatch-active', 'true');
      hideTouchHoverImages(productImage);
    }
  }

  function hideTouchHoverImages(productImage) {
    var hoverImages = productImage.querySelector('hover-images');

    if (!hoverImages) {
      return;
    }

    hoverImages.style.opacity = '0';
    hoverImages.style.visibility = 'hidden';
    hoverImages.style.pointerEvents = 'none';
  }

  if (window.PointerEvent) {
    document.addEventListener('pointerup', previewGridSwatchOnTouch, true);
  }

  document.addEventListener('touchend', previewGridSwatchOnTouch, true);
  document.addEventListener('click', previewGridSwatchOnTouch, true);






  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
